import { Participant, User } from '@core/interfaces/users.interface'

export const adapterUser = (participant: Participant): User => {
  return {
    authenticated: participant.authenticated,
    nombres: participant.nombres,
    apellidos: participant.apellidos,
    id: participant.id,
    id_empleado: participant.id_empleado,
    uid: participant.uid,
    name: participant.nombre_completo,
    email: participant.email,
    celular: participant.celular,
    plaza: participant.plaza,
    region: participant.region,
    tienda: participant.tienda,
    nombre_tienda: participant.nombre_tienda,
    rol: participant.rol,
    avatar: participant.avatar ?? 'https://superlikers-themes.s3.us-east-1.amazonaws.com/oxxo/perfil/personajes/Foto_default.png',
    points: participant.points,
    total_points: participant.total_points,
    email_verified: participant.email_verified,
    last_access: participant.last_access,
    last_access_date: participant.last_access_date,
    cargo: participant.cargo,
    nivel: participant.nivel
  }
}
